// 앱 부트스트랩. pinia → router → mount 순서로 초기화하고 페이지 제목을 환경변수로 설정
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import routes from '~pages'
import pinia from '@/stores'
import App from './App.vue'
import './styles/tailwind.css'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...routes,
    {
      path: '/:pathMatch(.*)*',
      redirect: '/projects',
    },
  ],
})

router.beforeEach((to, _from, next) => {
  const baseTitle = import.meta.env.VITE_APP_TITLE || 'Carrot Replay Admin'
  if (to.meta.title) {
    document.title = `${to.meta.title} - ${baseTitle}`
  } else {
    document.title = baseTitle
  }
  next()
})

const app = createApp(App)
app.use(pinia)
app.use(router)
app.config.globalProperties.$env = import.meta.env

app.mount('#app')

if (import.meta.env.DEV) {
  console.log(
    '📋 Available Routes:',
    routes.map(route => ({
      path: route.path,
      name: route.name,
    }))
  )
}
